import * as React from 'react';
import CarouselItem from "./CarouselItem/CarouselItem";

class Carousel extends React.Component {
  state = {
    selected: 0,
    intervalId: '',
    isSetInterval: false
  };

  //AUTOMATIC SWITCHING OF SLIDES

  componentDidUpdate(prevProps) {
    const { isSetInterval } = this.state;
    const { isVisible } = this.props;

    if (prevProps.isVisible !== isVisible) {
      if (isVisible && !isSetInterval) {
        this.setSlidesInterval();
      } else if (!isVisible) {
        this.clearSlidesInterval();
      }
    }
  }

  setSlidesInterval() {
    const intervalId = setInterval(() => this.updateSelectedSlide(), 6000);
    this.setState({ intervalId, isSetInterval: true });
  }

  clearSlidesInterval() {
    clearInterval(this.state.intervalId);
    this.setState({ isSetInterval: false });
  }

  updateSelectedSlide = () => {
    const { slides } = this.props;

    this.setState(state => ({
      selected: state.selected === slides.length - 1 ? 0 : state.selected + 1
    }))
  };

  handleClick = selected => {
    this.setState({ selected });
    this.clearSlidesInterval();
  };

  render() {
    const { selected } = this.state;
    const { slides, color, smallImg } = this.props;

    return (
      <>
        {slides.map((item, index) => (
          index === selected &&
          <CarouselItem img={item.img}
                        key={index}
                        color={color}
                        {...item}
                        slides={slides}
                        selected={selected}
                        click={this.handleClick}
                        smallImg={smallImg}
          />
        ))}
      </>
    )
  }
}

export default Carousel;
